import { render, staticRenderFns } from "./u-dialog-flat-tile.vue?vue&type=template&id=179605a9&scoped=true&"
import script from "./u-dialog-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-dialog-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179605a9",
  null
  
)

export default component.exports